import { render, staticRenderFns } from "./DeviceMonitorTemplateTypeUpdateBox.vue?vue&type=template&id=2a88fcab"
import script from "./DeviceMonitorTemplateTypeUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorTemplateTypeUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports